var _defs, _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    id: "call-center",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -19.937,
    x2: 466.521,
    y1: 451.937,
    y2: -34.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#00d7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006df0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 28.063,
    x2: 514.521,
    y1: 499.937,
    y2: 13.479,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 55.178,
    x2: 541.636,
    y1: 527.051,
    y2: 40.593,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 44.063,
    x2: 530.521,
    y1: 515.937,
    y2: 29.479,
    xlinkHref: "#a"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 224,
    r: 16,
    fill: "url(#a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 224,
    r: 16,
    fill: "url(#b)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M446,436.36c-12.26-18.23-29.17-30.94-47.6-35.79L312,377.83V348.11c21.38-14.33,40.57-35.44,49.95-60.11H384a8,8,0,0,0,8-8v64h-8a8,8,0,0,0-8-8H344a8,8,0,0,0-8,8v23a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8v-7h16a8,8,0,0,0,8-8V279.6A20.035,20.035,0,0,0,424,260V204a20.035,20.035,0,0,0-16-19.6V160C408,76.19,339.81,8,256,8S104,76.19,104,160v24.4A20.035,20.035,0,0,0,88,204v56a20.02,20.02,0,0,0,20,20h12a8,8,0,0,0,8,8h22.05c9.38,24.67,28.57,45.78,49.95,60.11v29.72l-86.39,22.74C95.17,405.42,78.26,418.13,66,436.36c-11.61,17.27-18,37.62-18,57.31V496a8,8,0,0,0,8,8H456a8,8,0,0,0,8-8v-2.33C464,473.98,457.61,453.63,446,436.36ZM368,359H352v-7h16ZM352,187.31a79.215,79.215,0,0,1-41.3-31.53,8.009,8.009,0,0,0-10.77-2.37c-.6.37-59.24,35.26-139.93,37.48V160a96,96,0,0,1,192,0ZM376,272h-8V192h8Zm32-68v56a4,4,0,0,1-4,4H392V200h12A4,4,0,0,1,408,204ZM120,264H108a4,4,0,0,1-4-4V204a4,4,0,0,1,4-4h12Zm24,8h-8V192h8Zm0-112v16H128a8,8,0,0,0-8,8V160c0-74.99,61.01-136,136-136S392,85.01,392,160v24a8,8,0,0,0-8-8H368V160a112,112,0,0,0-224,0Zm50.34,163.58C164.46,296.8,160,269.75,160,256V206.89c70.26-1.8,123.83-26.71,141.78-36.2A93.971,93.971,0,0,0,352,203.94V256c0,13.75-4.46,40.8-34.34,67.58C298.4,340.84,274.19,352,256,352S213.6,340.84,194.34,323.58ZM296,357.38v22.87l-40,33.34-40-33.34V357.38c13.85,6.81,27.82,10.62,40,10.62S282.15,364.19,296,357.38ZM384,488V472a8,8,0,0,0-16,0v16H144V472a8,8,0,0,0-16,0v16H64.21c2.41-33.03,25.47-64.59,53.47-71.95l88.37-23.26,44.83,37.36a8,8,0,0,0,10.24,0l44.83-37.36,88.38,23.26c27.99,7.36,51.05,38.92,53.46,71.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M280,304a8,8,0,0,0-8-8H240a8,8,0,0,0,0,16h32A8,8,0,0,0,280,304Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenter);
export default __webpack_public_path__ + "static/media/call-center.3c0da4bf08bc512c76a8b471c083100a.svg";
export { ForwardRef as ReactComponent };